export default function Hero() {
  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-white min-h-[calc(100svh-4rem)] sm:min-h-[calc(100svh-5rem)] md:h-[calc(100vh-6rem)]"
    >
      <div className="container mx-auto flex h-full flex-col px-4 pt-6 sm:px-6 sm:pt-8 md:pt-10 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="text-3xl font-bold leading-tight tracking-tight text-neutral-900 sm:text-5xl md:text-6xl">
            <span>"The App made for </span>
            <span className="inline-block italic text-[#00af19]">Tourists"</span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-neutral-500 sm:text-base">
            An end-to-end tourism platform dedicated to making your journey a bit
            easier. Join us and begin discovering the world around you!
          </p>

          <a
            href={process.env.REACT_APP_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex min-w-[170px] items-center justify-center rounded-full bg-gradient-to-r from-[#2ea0d1] to-[#00af19] px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-500/20 transition hover:scale-105 sm:mt-8"
          >
            SIGN UP
          </a>
        </div>

        <div className="relative mx-auto mt-36 w-full max-w-5xl flex-1 overflow-hidden sm:mt-8 md:mt-10">
          <img
            src="/dots.png"
            alt="Decorative dotted background"
            className="mx-auto w-full max-w-5xl opacity-90"
          />

          <div className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-center">
            <img
              src="/screen1.png"
              alt="TourPin app screen"
              className="z-10 w-[70%] min-w-[112px] max-w-[360px] translate-y-[14%] -mr-28 md:w-[40%] md:-mr-44 lg:w-[44%] lg:-mr-56 xl:w-[44%] xl:-mr-56 drop-shadow-2xl"
            />
            <img
              src="/screen2.png"
              alt="TourPin app chatbot screen"
              className="z-20 w-[88%] min-w-[152px] max-w-[460px] translate-y-[3%] sm:w-[54%] md:w-[52%] drop-shadow-2xl"
            />
            <img
              src="/screen3.png"
              alt="TourPin app map screen"
              className="z-10 w-[70%] min-w-[112px] max-w-[360px] translate-y-[14%] -ml-28 md:w-[40%] md:-ml-44 lg:w-[44%] lg:-ml-56 xl:w-[44%] xl:-ml-56 drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
